import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box, Typography, Grid } from '@mui/material';

function CoachingBenefitsCard({ subtitle, description, picture, index }) {
  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        height: '100%',
        borderRadius: 6,
        minWidth: '288px',
        p: '32px 16px 20px 16px',
        bgcolor: 'kit.background.lightpurple',
      }}
    >
      <Typography
        fontSize="22px"
        variant="desktopH2"
        color="kit.text.main"
        sx={{ mb: 2 }}
      >
        {subtitle}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ minHeight: 200 }}>
          <Typography
            color="kit.text.secondary"
            variant="desktopP2"
            fontSize="14px"
          >
            {description}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
          }}
        >
          <GatsbyImage
            imgStyle={{
              minWidth: '241px',
            }}
            image={getImage(picture)}
            alt={`you_will_get-${index}`}
            loading="lazy"
          />
        </Box>
      </Box>
    </Box>
  );
}

export default CoachingBenefitsCard;
